import { Component, OnInit } from '@angular/core';
import { NgModule } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms'
import { PartnerService } from '../../services/partner.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'app-partner-dashboard',
  templateUrl: './partner-dashboard.component.html',
  styleUrls: ['./partner-dashboard.component.scss']
})
export class PartnerDashboardComponent implements OnInit {
  statusMessage: string = "Loading data please wait...";
  //orderItemList : Observable<any>;
  orderItemList:any[];
  isPageEditable:boolean=true;
  constructor(private _partnerService: PartnerService, private router: Router, private fb: FormBuilder) { }

  ngOnInit() {
    this.getOrder();
  }

  getOrder() {   
    this._partnerService.getPartnerOrder()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.orderItemList = employeeData.response.order.filter (t=> t.isOrderdelivered==false)
          }
          console.log(this.orderItemList)
        
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }

  showList(item)
  {
    if (item.IsDisplayItem)
    {
      item.IsDisplayItem=false;
    }
    else{
      item.IsDisplayItem=true;
    }
  }

  updateOrderDeliveryStatus(order) {   
    let confimationMessage = "Are you sure this order is deliver to " + order.patientName;
    if (confirm(confimationMessage)) {    
      var loginUser = JSON.parse(localStorage.getItem('currentUser')); 
      order.token =loginUser.token;
      this._partnerService.updateOrderDeliveryStatus(order).subscribe(
       
        data => {
          if (data.returnCode == 0) {
            alert("Record updated sucessfully")
            this. getOrder();

          }
          else {
            if (data.returnCode == 2) {


            }
          }
         
        },
        error => {
          // this.alertService.error(error);
          // this.loading = false;         
          alert(error)
          console.log(error)
        });
    }


  }

}



// WEBPACK FOOTER //
// ./src/app/partnerUI/partner-dashboard/partner-dashboard.component.ts